// NOTE: PokeSol向け定型文で使用する名称置換テーブル
export const POKESOL_NAME_MAPPING: Record<string, string> = {
  'バドレックス(こくばじょうのすがた)': 'バドレックス(黒馬)',
  'バドレックス(はくばじょうのすがた)': 'バドレックス(白馬)',
  'ウーラオス(れんげきのかた)': 'ウーラオス(連撃)',
  'ウーラオス(いちげきのかた)': 'ウーラオス(一撃)',
  'ザシアン(れきせんのゆうしゃ)': 'ザシアン(勇者)',
  'ザシアン(けんのおう)': 'ザシアン(剣の王)',
  'ザマゼンタ(れきせんのゆうしゃ)': 'ザマゼンタ(勇者)',
  'ザマゼンタ(たてのおう)': 'ザマゼンタ(盾の王)',
  'ネクロズマ(あかつきのつばさ)': 'ネクロズマ(月食)',
  'ネクロズマ(たそがれのたてがみ)': 'ネクロズマ(日食)',
  'ランドロス(れいじゅうフォルム)': 'ランドロス(霊獣)',
  'ランドロス(けしんフォルム)': 'ランドロス(化身)',
  'トルネロス(れいじゅうフォルム)': 'トルネロス(霊獣)',
  'トルネロス(けしんフォルム)': 'トルネロス(化身)',
  'ボルトロス(れいじゅうフォルム)': 'ボルトロス(霊獣)',
  'ボルトロス(けしんフォルム)': 'ボルトロス(化身)',
  'ラブトロス(れいじゅうフォルム)': 'ラブトロス(霊獣)',
  'ラブトロス(けしんフォルム)': 'ラブトロス(化身)',
  'オーガポン(かまどのめん)': 'オーガポン(炎)',
  'オーガポン(いしずえのめん)': 'オーガポン(岩)',
  'オーガポン(いどのめん)': 'オーガポン(水)',
  'オーガポン(みどりのめん)': 'オーガポン',
  'テラパゴス(ノーマルフォルム)': 'テラパゴス(ノーマル)',
  'テラパゴス(テラスタルフォルム)': 'テラパゴス(テラスタル)',
  'テラパゴス(ステラフォルム)': 'テラパゴス(ステラ)',
  'ミライドン(コンプリートモード)': 'ミライドン',
  'コライドン(かんぜんけいたい)': 'コライドン',
  'カイオーガ(カイオーガのすがた)': 'カイオーガ',
  'グラードン(グラードンのすがた)': 'グラードン',
};

/**
 * ポケソル用に表示名をそろえるヘルパー
 */
export const formatPokesolDisplayName = (originalName: string): string => {
  return POKESOL_NAME_MAPPING[originalName] ?? originalName;
};
